import {
  UserAppServices,
  UserPreferencesAppServices,
} from "../services/user/user.service";
import { createQueryKeys } from "@lukemorales/query-key-factory";

const UserQueries = createQueryKeys("user", {
  getCurrent: () => ({
    queryKey: ["current"],
    queryFn: () => UserAppServices.getCurrent(),
  }),
  getByID: (id: string) => ({
    queryKey: [id],
    queryFn: () => UserAppServices.getByID(id),
  }),
});

const UserPreferencesQueries = createQueryKeys("user-preferences", {
  getByUserID: (userID: string) => ({
    queryKey: ["user", userID],
    queryFn: () => UserPreferencesAppServices.getByUserID(userID),
  }),
});

export { UserQueries, UserPreferencesQueries };
